import request from '@/utils/request'
// 用户认证
export function userAuth(data) {
    return request({
        url: '/swx/customer/user/identification',
        method: 'post',
        data
    })
}
// 用户信息
export function getUserInfo(data) {
    return request({
        url: '/swx/customer/user/getUserInfo',
        method: 'post',
        data
    })
}
// recharge
export function recharge(data) {
    return request({
        url: '/swx/customer/user/recharge',
        method: 'post',
        data
    })
}
export function scanRecharge(recordId) {
    return request({
        url: '/swx/customer/user/recharge/scan',
        method: 'post',
        params: { recordId }
    })
}
// 提现
// withdrawal
export function withdrawal(data) {
    return request({
        url: '/swx/customer/user/withdrawal',
        method: 'post',
        data
    })
}

// 获取用户实际提现手续费率（包含VIP减免）
export function getWithdrawalFeeInfo() {
    return request({
        url: '/swx/customer/user/withdrawalFeeInfo',
        method: 'get'
    })
}

// 获取用户充值地址（用户专属 > 所属代理配置 > 平台默认）
export function getUserRechargeAddresses() {
    return request({
        url: '/swx/customer/user/rechargeAddresses',
        method: 'get'
    })
}

// buyNft
export function buyNft(data) {
    return request({
        url: `/swx/customer/user/buyNft`,
        method: 'post',
        data
    })
}
// listNft
export function userListNft(param) {
    return request({
        url: `/swx/customer/user/listNft`,
        method: 'get',
        params: {
            ...param
        }
    })
}
// loan
export function loan(data) {
    return request({
        url: `/swx/customer/user/loan`,
        method: 'post',
        data
    })
}

// listInviteRebate 邀请返利记录
export function listInviteRebate(param) {
    return request({
        url: `/swx/customer/user/listInviteRebate`,
        method: 'get',
        params: {
            ...param
        }
    })
}

export function getInviteActivityInfo() {
    return request({
        url: `/swx/customer/inviteActivity/info`,
        method: 'get'
    })
}

export function claimInviteReward(data) {
    return request({
        url: `/swx/customer/inviteActivity/claim`,
        method: 'post',
        data: data || {}
    })
}

export function listTrialCoupons() {
    return request({
        url: `/swx/customer/inviteActivity/coupons`,
        method: 'get'
    })
}
// listRecharge 充值订单
export function listRecharge(param) {
    return request({
        url: `/swx/customer/user/listRecharge`,
        method: 'get',
        params: {
            ...param
        }
    })
}
// listWithdrwal 提现订单
export function listWithdrwal(param) {
    return request({
        url: `/swx/customer/user/listWithdrwal`,
        method: 'get',
        params: {
            ...param
        }
    })
}
// listLoanRecord 借贷订单
export function listLoanRecord(param) {
    return request({
        url: `/swx/customer/user/listLoanRecord`,
        method: 'get',
        params: {
            ...param
        }
    })
}
// /swx/customer/user/repassword
export function repassword(data) {
    return request({
        url: `/swx/customer/user/repassword`,
        method: 'post',
        data
    })
}

export function getPriceByCode(code){
    return request({
        url: `/swx/customer/index/getPrice/${code}`,
        method: 'get'
    })
}

// /swx/customer/user/repassword
export function getPriceBitcoin(data) {
    return request({
        url: `/swx/customer/index/getPrice/bitcoin`,
        method: 'get'
    })
}

export function getPriceEthereum(data) {
    return request({
        url: `/swx/customer/index/getPrice/ethereum`,
        method: 'get'
    })
}

// 获取用户协议
export function customContents(param) {
    return request({
        url: `/swx/customer/index/getCustomContents`,
        method: 'get',
        params: {
            ...param
        }
    })
}

// 用户还款
export function repayLoan(data) {
    return request({
        url: `/swx/customer/user/repayLoan`,
        method: 'post',
        params: {
            ...data
        }
    })
}

// 获取通知列表
export function getNotificationList(data) {
    return request({
        url: '/swx/customer/user/getNotificationList',
        method: 'post',
        data
    })
}

// 标记通知为已读
export function markNotificationRead(data) {
    return request({
        url: '/swx/customer/user/markNotificationRead',
        method: 'post',
        data
    })
}

// 设置提现PIN码
export function setWithdrawalPin(data) {
    return request({
        url: '/swx/customer/user/setWithdrawalPin',
        method: 'post',
        data
    })
}

// 修改提现PIN码（需原PIN）
export function changeWithdrawalPin(data) {
    return request({
        url: '/swx/customer/user/changeWithdrawalPin',
        method: 'post',
        data
    })
}

// 验证提现PIN码
export function verifyWithdrawalPin(data) {
    return request({
        url: '/swx/customer/user/verifyWithdrawalPin',
        method: 'post',
        data
    })
}